import React from "react";
import { MainCP } from "../../../Components/nueva-constitucion/nueva-constitucion-v2/MainCP"

const ViewNuevaConstitucionV2: React.FC = () => <MainCP/>
export default ViewNuevaConstitucionV2;